<template>
	<div class="attachment">
		<api-error v-for="e in allErrors" :level="e.level" :message="e.message"></api-error>
		<div v-for="item in items" class="attDiv">
			<a v-if="!readOnly" class="fakeHref" :title="titleRemoveAtt" @click="removeAttachment(item);">
				<sym-icon name="cross-14"/>
			</a>
			<a :href="getContentItemApi(item)" target="_blank" :title="item.name" class="attName">{{item.name}}</a>
			<span class="att-size">{{item.size}}</span>
		</div>
	</div>
</template>

<script setup lang="ts">
	import {ref, computed, reactive} from 'vue';
	import {injectEnv} from "@fd/Environment";
	import SymIcon from "@fd/helpers/SymIcon.vue";
	import ApiError from "@/fd/helpers/ApiError.vue";
	import type {MailAttachment} from '@t/mail/MailForm.ts';
	import type {ErrorMap} from "@fd/PartInjectKeys.ts";
	
	const props = defineProps<{
	  mailIdent: number;
	  readOnly?: boolean;
	  errors?: ErrorMap;
	}>();
	

	const items = defineModel<MailAttachment[]>({ default: [] });
	const env = injectEnv();
	const errorMessage = ref("");
	const localErrors = reactive<ErrorMap>([]);
	
	const titleRemoveAtt = computed(() => {
		return env.msg("title.deleteAttachment");
	});
	
	const allErrors = computed<ErrorMap>(() => {
		return [...props.errors,...localErrors];
	});
	
	
	function loadAttachments() {
		localErrors.length = 0;
		return env.net.fetch("api/attachments?mailIdent="+props.mailIdent)
			.then(response => response.json())
			.then(data => {
				console.log("Loaded attachments for mailIdent:"+props.mailIdent+" - "+JSON.stringify(data));
				items.value=data;
			})
			.catch((error) => {
				console.log("error refresh data:"+error);
				localErrors.push({level:"SEVERE", message: env.msg("adminMessage.error.server")+error.message});
			});
	}
	
	defineExpose({loadAttachments});
	
	function getContentItemApi(item: MailAttachment) {
		return "api/attachments/"+item.id+"/content?mailIdent="+props.mailIdent;
	}
	
	function getItemApi(item: MailAttachment) {
		return "api/attachments/"+item.id+"?mailIdent="+props.mailIdent;
	}
	
	function removeAttachment(toRemoveItem: MailAttachment) {
		localErrors.length = 0;
		env.net.fetch(getItemApi(toRemoveItem), "DELETE")
		.then(response => {
			if (response.ok) {
				let newItems = items.value.filter(item => item.id !== toRemoveItem.id);
				items.value=newItems;
			}
			else {
				console.error('Error status:', response.status);
				localErrors.push({level:"SEVERE", message: env.msg("adminMessage.error.server")});
			}
		})
		.catch((error) => {
		  console.error('Error removing attachment:', error);
		  localErrors.push({level:"SEVERE", message: env.msg("adminMessage.error.server")+error.message});
		});
	}	
</script>

